//Global External Imports
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Route, Routes, useNavigate } from "react-router-dom";
//Global Internal Imports
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useMessage } from "../../context/message-context";
import apiRequest from "../../functions/api";
import { SearchTextField } from "../lib";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Layout from "../shared/components/LayoutComponent";
import Page from "../shared/components/PageComponent";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import FormularEingabe from "./FormularEingabe";
// {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
import { FilterList, InfoOutlined } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import HistoryIcon from "@mui/icons-material/History";
import { useMemo } from "react";
import { LOCAL_STORAGE_KEY } from "../../constants/localStorage";
import { debounce } from "../../functions/debounce";
import { pad } from "../../functions/default";
import { formatDate } from "../../functions/formatDate";
import LohnartenDesktopUebersicht from "./LohnartenDesktopUebersicht";
import LohnartenMobileUebersicht from "./LohnartenMobileUebersicht";
//Child Imports
function Formulare(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { client, accessToken } = props;
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const navigate = useNavigate();
  const [formulare, setFormulare] = useState([]);
  const [formularliste, setFormularliste] = useState([]);
  const [formular, setFormular] = useState(0);
  const [workflow, setWorkflow] = useState(0);
  const [neuFormular, setNeuFormular] = useState(0);
  const [ladenFormular, setLadenFormular] = useState(0);
  const [open, setOpen] = useState(0);
  const [formularDetailsRow, setFormularDetailsRow] = useState(-1);
  const [formularDetailsLoa, setFormularDetailsLoa] = useState(-1);
  const [formularnummer, setFromularnummer] = useState();
  const [reload, setReload] = useState();
  const [anAuswahl, setAnAuswahl] = useState(false);
  const [ans, setAns] = useState({});
  const ankey = useRef("");
  const loadIndex = useRef(-1);
  const [filter, setFilter] = useState("");
  const [spalten, setSpalten] = useState([]);
  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState([]);
  const [statusFilterSelectValue, setStatusFilterSelectValeue] = useState([]);
  const [monatsErgebnisse, setMonatsErgebnisse] = useState([]);
  const [showLohnarten, setShowLohnarten] = useState(localStorage.getItem(LOCAL_STORAGE_KEY.form_showLohnarten) === "true" ? true : false);
  const [formularFilter, setFormularFilter] = useState([]);
  const [formularFilterSelectValue, setFormularFilterSelectValue] = useState([]);
  const [filterDialog, setFilterDialog] = useState(false);
  const [bearbeiten, setBearbeiten] = useState(false);
  const [datumsFilter, setDatumsFilter] = useState(
    new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000).getFullYear().toString() +
      "-" +
      pad(new Date(new Date().getTime() - 90 * 24 * 60 * 60 * 1000).getMonth() + 1, 2) +
      "-" +
      "01",
    // qpad(new Date(new Date().getTime() -90 * 24 * 60 * 60 * 1000).getDate(), 2)
  );
  const formularLoa = formulare.find((e) => e.key === formularDetailsLoa);
  const hatAuszahlung = formularLoa?.auszahlung?.length > 0;

  const [zeilen, setZeilen] = useState([]);

  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");
  useEffect(() => {
    console.log(showLohnarten);
    // eslint-disable-next-line
  }, []);

  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };
  //PVX Kommunikation
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client,
      program: "FORMUL",
      statement: "UEBERSICHT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postUebersicht(r));
    getLohnartenUebersicht();
    // eslint-disable-next-line
  }, [reload]);

  const getLohnartenUebersicht = () => {
    const payload = {
      mandant: client,
      program: "FORMUL",
      statement: "LOHNARTEN_UEBERSICHT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => lohnartenCB(r));
  };
  const lohnartenCB = (response) => {
    setMonatsErgebnisse(response.data.monatsErgebnisse);
  };
  useEffect(() => {
    if (formulare.length > 0) {
      filterFormulare(formulare, search, statusFilter, formularFilter);
    }
    // eslint-disable-next-line
  }, [search]);

  useEffect(() => {
    setFormularFilter(formularFilterSelectValue?.map((formular) => formularFilterOptions.find((e) => e.value === formular)));
  }, [formularFilterSelectValue]);
  useEffect(() => {
    setStatusFilter(statusFilterSelectValue?.map((status) => statusFilterOptions.find((e) => e.value === status)));
  }, [statusFilterSelectValue]);

  useEffect(() => {
    filterFormulareDirekt(formulare, search, statusFilter, formularFilter, datumsFilter);
  }, [datumsFilter, statusFilter, formularFilter]);

  const filterFormulare = useMemo(
    () =>
      debounce((formulare, search, statusFilter, formularFilter) => {
        var formFilter = formularFilter.map((e) => e.value);
        var stateFilter = statusFilter.map((e) => e.value);
        var tmpliste = [];
        formulare
          .filter((it) => {
            if (search && (it.bez + it.statusorig + it.statustext + it.anzdatum).toLowerCase().includes(search?.toLowerCase()) === false) return false;
            if (formFilter.length > 0 && !formFilter.includes(it.formularBez)) return false;
            if (stateFilter.length > 0 && !stateFilter.includes(it.statusorig)) return false;
            return true;
          })
          .forEach((item, index) => {
            tmpliste.push(item);
          });
        setZeilen(tmpliste);
      }, 250),
    [],
  );
  const filterFormulareDirekt = (formulare, search, statusFilter, formularFilter, datumsFilter) => {
    var formFilter = formularFilter.map((e) => e.value);
    var stateFilter = statusFilter.map((e) => e.value);
    var tmpliste = [];
    var datumsIndex = formulare.findIndex((obj) => obj.datum < datumsFilter.replace(/\-/g, ""));
    if (datumsIndex === -1) {
      datumsIndex = formulare.length;
    }
    formulare
      .slice(0, datumsIndex)
      .filter((it) => {
        if (search && (it.bez + it.statusorig + it.statustext + it.anzdatum).toLowerCase().includes(search.toLowerCase()) === false) return false;
        if (formFilter.length > 0 && !formFilter.includes(it.formularBez)) return false;
        if (stateFilter.length > 0 && !stateFilter.includes(it.statusorig)) return false;
        return true;
      })
      .forEach((item, index) => {
        tmpliste.push(item);
      });
    setZeilen(tmpliste);
  };

  const formularFilterOptions = useMemo(() => {
    const filter = formulare
      ?.filter((value, index, array) => array.findIndex((element) => element.formularBez === value.formularBez && element.formularBez !== "") === index)
      .map((element) => ({
        value: element.formularBez,
        label: element.formularBez,
      }));
    return filter;
  }, [formulare]);

  const statusFilterOptions = useMemo(() => {
    const filter = formulare
      ?.filter((value, index, array) => array.findIndex((element) => element.statusorig === value.statusorig) === index)
      .map((element) => ({
        value: element.statusorig,
        label: element.statusorig,
        color: element.color,
      }));
    if (!filter.find((e) => e.label === "offen")) {
      filter.push({ value: "offen", label: "offen", color: "red" });
    }
    return filter;
  }, [formulare]);

  function postUebersicht(response) {
    setIsLoading(false);
    if (response.status === 200) {
      if (response.data.formulare) {
        const zwisFormulare = response.data.formulare.sort((a, b) => b.datum - a.datum);
        filterFormulareDirekt(zwisFormulare, search, statusFilter, formularFilter, datumsFilter);

        setFormulare(zwisFormulare);
      } else {
        setFormulare([]);
      }
      if (response.data.formularliste) {
        setFormularliste(response.data.formularliste);
      } else {
        setFormularliste([]);
      }
      setSpalten(response.data.spalten || []);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  //Standardfunktionen
  if (isLoading) {
    return <LoadingComponent path={props.location} />;
  }
  function Reload() {
    setReload(!reload);
  }
  function Neu() {
    if (formularliste && formularliste.length > 0) {
      setOpen(1);
    } else {
      showErrorMessage(t("Es sind keine Formulare freigeschalten"));
    }
  }
  function NeuesFormular() {
    setBearbeiten(false);

    Reset();
    if (formularliste[neuFormular].an === "J") {
      setAns(formularliste[neuFormular].ans);
      setAnAuswahl(true);
      return;
    }
    setLadenFormular("neu");
    setFormular(formularliste[neuFormular].formular);
    setWorkflow(formularliste[neuFormular].workflow);
    loadIndex.current = neuFormular;
    navigate("/FORMUL/" + "neu");
  }
  function AuswahlAn(key) {
    Reset();
    ankey.current = key;
    setLadenFormular("neu");
    setFormular(formularliste[neuFormular].formular);
    setWorkflow(formularliste[neuFormular].workflow);
    loadIndex.current = neuFormular;
    navigate("/FORMUL/" + "neu");
  }
  function Bearbeiten(key) {
    setBearbeiten(true);

    Reset();
    setLadenFormular(key);
    loadIndex.current = formularliste.findIndex((p) => p.formular === key.substr(7, 3));
    if (loadIndex.current !== -1) {
      // setFormular(formularliste[loadIndex.current].workflow);
      // showErrorMessage("Sie sind nicht mehr für dieses Formular freigeschalten!")
      // return
    }
    setFormular(key.substr(7, 3));
    navigate("/FORMUL/" + key);
  }
  function Reset() {
    setOpen(0);
    setAnAuswahl(false);
    ankey.current = "";
    setFilter("");
  }
  const sortZeilen = (zeilen, sortColumn, sortDirection) => {
    if (sortColumn === "zeitraum") {
      if (sortDirection === "asc") {
        return zeilen.sort((a, b) => a.datum - b.datum);
      }
      if (sortDirection === "desc") {
        return zeilen.sort((a, b) => b.datum - a.datum);
      }
    }

    return zeilen;
  };
  const changeShowLohnarten = (e) => {
    setShowLohnarten(e.target.checked);
    localStorage.setItem(LOCAL_STORAGE_KEY.form_showLohnarten, e.target.checked);
  };

  const jahresAuswertungDrucken = () => {
    const payload = {
      mandant: client,
      program: "FORMUL",
      statement: "JAHRES_AUSWERTUNG_DRUCKEN",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => console.log(r));
  };
  //Renderfunktionen
  function renderNeu() {
    return (
      <Fragment>
        <ResponsiveDialog
          title={t("Neues Formular")}
          open={open === 1}
          setOpen={() => setOpen(0)}
          actionButton={
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button variant="outlined" color="primary" onClick={() => Reset()}>
                  {t("Abbrechen")}
                </Button>
              </Grid>
              <Grid item>
                <Button variant="outlined" color="primary" onClick={() => NeuesFormular()}>
                  {t("Auswahl")}
                </Button>
              </Grid>
            </Grid>
          }
        >
          <Box p={2}>
            <Grid container justifyContent="center" spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  size="small"
                  variant="outlined"
                  label={t("Formular")}
                  value={neuFormular}
                  select
                  onChange={(e) => setNeuFormular(e.target.value)}
                >
                  {formularliste.map((item, index) => {
                    if (item.gesperrt !== "1") {
                      return (
                        <MenuItem key={index} value={index} index={index}>
                          {item.key + " - " + item.bez}
                        </MenuItem>
                      );
                    }
                  })}
                </TextField>
              </Grid>
            </Grid>
          </Box>
        </ResponsiveDialog>
        <ResponsiveDialog
          title={t("Auswahl Mitarbeiter")}
          open={anAuswahl}
          setOpen={(o) => {
            Reset();
            setAnAuswahl(false);
          }}
        >
          <Box p={2}>
            <SearchTextField
              fullWidth
              label={t("Suche")}
              id="filter"
              variant="outlined"
              value={filter}
              inputProps={{
                autoCapitalize: "off",
                autoCorrect: "off",
                spellCheck: "false",
                autoComplete: "off",
              }}
              onChange={(e) => setFilter(e.target.value)}
            />
          </Box>
          <TableContainer>
            <Table>
              <TableBody>
                {ans &&
                  ans.length > 0 &&
                  ans
                    .filter((item) => {
                      if (item.name.toLowerCase().includes(filter.toLowerCase()) === false) return false;
                      return true;
                    })
                    .map((item) => {
                      return (
                        <TableRow style={{ cursor: "pointer" }} onClick={() => AuswahlAn(item.key)} hover>
                          <TableCell>
                            {item.name}
                            {zeilen.find((e) => e.annr === item.key && e.formularKey === formularliste[neuFormular].formular) && (
                              <>
                                <CheckIcon />
                                <Typography variant="caption">
                                  {"(" +
                                    t("Bereits am: ") +
                                    zeilen.find((e) => e.annr === item.key && e.formularKey === formularliste[neuFormular].formular).anzdatum +
                                    t(" ausgefüllt") +
                                    ")"}
                                </Typography>
                              </>
                            )}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                {(!ans || ans.length <= 0) && (
                  <TableRow>
                    <TableCell>{t("Es stehen keine Mitarbeiter zur Auswahl")}</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </ResponsiveDialog>
      </Fragment>
    );
  }
  function renderMobileAnsicht() {
    return (
      <>
        {formulare.length > 0 && (
          <>
            <Box display="flex" alignItems={"center"}>
              <SearchTextField
                size="small"
                fullWidth
                label={t("Suche")}
                id="search"
                variant="outlined"
                value={search}
                inputProps={{
                  autoCapitalize: "off",
                  autoCorrect: "off",
                  spellCheck: "false",
                  autoComplete: "off",
                }}
                style={{ marginRight: 16 }} // add spacing
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
              <Box pr={1}>
                <Tooltip title="Filter">
                  <IconButton color="primary" onClick={() => setFilterDialog(true)}>
                    <FilterList />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          </>
        )}

        <Box p={1}>
          <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
            <TableContainer sx={{ maxHeight: window.innerHeight - 250 }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ width: "5%" }} />
                    <TableCell style={{ width: "95%" }}></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {zeilen &&
                    zeilen.length > 0 &&
                    sortZeilen(zeilen, sortColumn, sortDirection).map((item, index) => {
                      return (
                        <>
                          <TableRow style={{ cursor: "pointer" }} onClick={() => Bearbeiten(item.key)} hover>
                            <TableCell style={{ width: "5%", padding: "0" }}>
                              {" "}
                              {item?.history?.length > 0 && (
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (index !== formularDetailsRow) {
                                      setFormularDetailsRow(index);
                                    } else {
                                      setFormularDetailsRow(-1);
                                    }
                                  }}
                                >
                                  {formularDetailsRow === index ? <KeyboardArrowUpIcon size="small" /> : <HistoryIcon />}
                                </IconButton>
                              )}
                            </TableCell>
                            <TableCell style={{ width: "5%", paddingLeft: "0" }}>
                              {/* <Box pt={1} pb={1}> */}
                              <Grid container justifyContent="flex-start">
                                <Grid item xs={7} align="left" style={{ display: "flex" }}>
                                  <Typography
                                    style={{
                                      fontWeight: 800,
                                      fontSize: "90%",
                                      display: "inline-block",
                                    }}
                                  >
                                    {item.bez}
                                  </Typography>
                                </Grid>
                                {item.statusorig === "von Personalabteilung bearbeitet" ? (
                                  <Grid item xs={12}>
                                    <Box display="flex" justifyContent="flex-end">
                                      <Chip
                                        size="small"
                                        label={item.statusorig}
                                        variant="outlined"
                                        style={{
                                          fontSize: "90%",
                                          width: "100%",
                                          backgroundColor: theme.palette.blocks[item.color],
                                        }}
                                      />
                                    </Box>
                                  </Grid>
                                ) : (
                                  <Grid item xs={12}>
                                    <Box display="flex" justifyContent="flex-end">
                                      <Chip
                                        size="small"
                                        label={item.statusorig}
                                        variant="outlined"
                                        style={{
                                          fontSize: "90%",
                                          width: "100%",
                                          backgroundColor: theme.palette.blocks[item.color],
                                        }}
                                      />
                                    </Box>
                                  </Grid>
                                )}
                                <Grid item xs={6} align="left" justifyItems={"between"}>
                                  <Typography
                                    style={{
                                      display: "inline-block",
                                      fontSize: "90%",
                                    }}
                                  >
                                    {item.vdat && item.vdat !== ""
                                      ? item.vdat.substr(8, 2) +
                                        "." +
                                        item.vdat.substr(5, 2) +
                                        "." +
                                        item.vdat.substr(0, 4) +
                                        " - " +
                                        item.bdat.substr(8, 2) +
                                        "." +
                                        item.bdat.substr(5, 2) +
                                        "." +
                                        item.bdat.substr(0, 4)
                                      : item.cdat && item.cdat !== ""
                                        ? item.cdat.substr(6, 2) + "." + item.cdat.substr(4, 2) + "." + item.cdat.substr(0, 4)
                                        : item.datum && item.datum !== ""
                                          ? item.datum?.substr(6, 2) + "." + item.datum?.substr(4, 2) + "." + item.datum?.substr(0, 4)
                                          : ""}
                                  </Typography>
                                </Grid>
                                <Grid item xs={6} align="right">
                                  {item?.lohnarten?.length > 0 && (
                                    <>
                                      <Button
                                        aria-label="expand row"
                                        size="medium"
                                        color="secondary"
                                        variant="text"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setFormularDetailsLoa(item.key);
                                        }}
                                      >
                                        {item.euroSumme}€
                                        <InfoOutlined />
                                      </Button>
                                    </>
                                  )}
                                  {item?.auszahlung?.length > 0 && (
                                    <>
                                      <Button
                                        aria-label="expand row"
                                        size="medium"
                                        color="secondary"
                                        variant="text"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setFormularDetailsLoa(item.key);
                                        }}
                                      >
                                        {item.auszahlung[0].auszahlenSummeEingabe +
                                          " " +
                                          (item?.auszahlung[0]?.selectedKonto?.auszahlungsart === "S" ? "Stunden" : "Tage")}
                                        <InfoOutlined />
                                      </Button>
                                    </>
                                  )}
                                </Grid>
                              </Grid>
                            </TableCell>
                          </TableRow>
                          <TableCell style={{ paddingBottom: 0, paddingTop: 0, margin: "0" }} colSpan={12}>
                            <Collapse in={formularDetailsRow === index} timeout="auto" unmountOnExit>
                              <Box>
                                <Typography variant="h6" gutterBottom align="center">
                                  {t("Verlauf")}
                                </Typography>
                                <Table size="small" aria-label="purchases" style={{ padding: "0", margin: "0" }}>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>
                                        <Typography fontWeight={530}>Person</Typography>
                                      </TableCell>
                                      <TableCell>
                                        <Typography fontWeight={530}>Aktion</Typography>
                                      </TableCell>
                                      <TableCell align="center">
                                        <Typography fontWeight={530}>Datum</Typography>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {item?.history
                                      ?.sort((a, b) => a.zeitstempel - b.zeitstempel)
                                      .map((historyRow) => (
                                        <TableRow key={historyRow.date}>
                                          <TableCell component="th" scope="row">
                                            {historyRow.person}
                                          </TableCell>
                                          <TableCell>{historyRow.aktion}</TableCell>
                                          <TableCell align="center">{historyRow.datum}</TableCell>
                                        </TableRow>
                                      ))}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </>
    );
  }
  function renderDesktopAnsicht() {
    return (
      <>
        {formulare.length > 0 && (
          <Grid container justifyContent="center" spacing={1} style={{ paddingTop: 20 }}>
            <Grid item xs={12} md={5}>
              <SearchTextField
                size="small"
                fullWidth
                label={t("Suche")}
                id="search"
                variant="outlined"
                value={search}
                inputProps={{
                  autoCapitalize: "off",
                  autoCorrect: "off",
                  spellCheck: "false",
                  autoComplete: "off",
                }}
                style={{ marginRight: 16 }} // add spacing
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Formulare anzeigen ab"
                value={datumsFilter}
                onChange={(e) => setDatumsFilter(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Autocomplete
                multiple
                onChange={(event, newValue) => {
                  setFormularFilter(newValue);
                }}
                value={formularFilter}
                size="small"
                id="tags-outlined"
                options={formularFilterOptions}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => <TextField {...params} label="Nach Formular filtern" placeholder="Formular" />}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <Autocomplete
                multiple
                onChange={(event, newValue) => {
                  setStatusFilter(newValue);
                }}
                value={statusFilter}
                size="small"
                id="tags-outlined"
                options={statusFilterOptions}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => <TextField {...params} size="small" label="Nach Status filtern" placeholder="Status" />}
              />
            </Grid>
          </Grid>
        )}
        <Box p={1}>
          <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
            <TableContainer sx={{ maxHeight: 950 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <HistoryIcon />
                    </TableCell>
                    <TableCell>Formular</TableCell>
                    <TableCell>Wert</TableCell>
                    <TableCell>
                      <TableSortLabel active={sortColumn === "zeitraum"} direction={sortDirection} onClick={() => handleSort("zeitraum")}>
                        Zeitraum
                      </TableSortLabel>
                    </TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Statuskennung</TableCell>
                    <TableCell>Statusänderung</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {zeilen &&
                    zeilen.length > 0 &&
                    sortZeilen(zeilen, sortColumn, sortDirection).map((item, index) => {
                      return (
                        <>
                          <TableRow style={{ cursor: "pointer" }} onClick={() => Bearbeiten(item.key)} hover>
                            <TableCell>
                              {item?.history?.length > 0 && (
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    if (index !== formularDetailsRow) {
                                      setFormularDetailsRow(index);
                                    } else {
                                      setFormularDetailsRow(-1);
                                    }
                                  }}
                                >
                                  {formularDetailsRow === index ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </IconButton>
                              )}
                            </TableCell>

                            <TableCell>{item.bez}</TableCell>
                            <TableCell>
                              {item?.lohnarten?.length > 0 && (
                                <>
                                  <Typography>{item.euroSumme}€</Typography>
                                  <IconButton
                                    aria-label="expand row"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setFormularDetailsLoa(item.key);
                                    }}
                                  >
                                    <InfoOutlined />
                                  </IconButton>
                                </>
                              )}
                              {item?.auszahlung?.length > 0 && (
                                <>
                                  <Typography>
                                    {item.auszahlung[0].auszahlenSummeEingabe +
                                      " " +
                                      (item?.auszahlung[0]?.selectedKonto?.auszahlungsart === "S" ? "Stunden" : "Tage")}
                                  </Typography>{" "}
                                  <IconButton
                                    aria-label="expand row"
                                    size="small"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setFormularDetailsLoa(item.key);
                                    }}
                                  >
                                    <InfoOutlined />
                                  </IconButton>
                                </>
                              )}
                            </TableCell>
                            {/* <TableCell>{item.datum.substr(6, 2) + "." + item.datum.substr(4, 2) + "." + item.datum.substr(0, 4)}</TableCell> */}
                            <TableCell>{item.anzdatum}</TableCell>
                            <TableCell>{item.statustext}</TableCell>

                            <TableCell>
                              <Chip
                                size="small"
                                label={item.statusorig}
                                variant="outlined"
                                style={{ backgroundColor: theme.palette.blocks[item.color], width: "100%" }}
                              />
                            </TableCell>
                            <TableCell>
                              <Typography>{item.statusdatum}</Typography>
                            </TableCell>
                          </TableRow>
                          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                            <Collapse in={formularDetailsRow === index} timeout="auto" unmountOnExit>
                              <Box sx={{ margin: 0, width: "100%" }}>
                                <Typography variant="h6" gutterBottom component="div" align="center">
                                  {t("Verlauf")}
                                </Typography>
                                <Table size="small" aria-label="history">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell align="center">Person</TableCell>
                                      <TableCell align="center">Aktion</TableCell>
                                      <TableCell align="center">Datum</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {item?.history
                                      ?.sort((a, b) => a.zeitstempel - b.zeitstempel)
                                      .map((historyRow) => (
                                        <>
                                          <TableRow key={historyRow.date}>
                                            <TableCell component="th" scope="row" align="center">
                                              {historyRow.person}
                                            </TableCell>
                                            <TableCell align="center">{historyRow.aktion}</TableCell>
                                            <TableCell align="center">{historyRow.datum}</TableCell>
                                          </TableRow>
                                        </>
                                      ))}
                                  </TableBody>
                                </Table>
                              </Box>
                            </Collapse>
                          </TableCell>
                        </>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </>
    );
  }

  function Uebersicht() {
    return (
      <Fragment>
        {renderNeu()}
        <Page>
          <Layout>
            <Grid container justifyContent="center" spacing={1}>
              <Grid item xs={12} md={6} lg={4}>
                <Box p={2}>
                  <Button fullWidth variant="outlined" color="primary" onClick={() => Neu()}>
                    {t("Neues Formular")}
                  </Button>
                </Box>
              </Grid>
              <hr align="center" width="100%" height="2px" />
              <Grid xs={12}>
                <Typography>{t("Ausgefüllte Formulare")}</Typography>
              </Grid>
              {/* <Button onClick={()=>jahresAuswertungDrucken()}>Jahresauswertung drucken</Button> */}
              {monatsErgebnisse?.length > 0 && (
                <>
                  <Grid item xs={12}>
                    <FormControlLabel control={<Switch checked={showLohnarten} onChange={changeShowLohnarten} />} label="Lohnarten anzeigen" />
                  </Grid>
                </>
              )}
            </Grid>
            {showLohnarten ? (
              <>
                <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>
                  <LohnartenMobileUebersicht
                    monatsErgebnisse={monatsErgebnisse}
                    Bearbeiten={Bearbeiten}
                    client={client}
                    accessToken={accessToken}
                    formularliste={formularliste}
                    Reload={Reload}
                    alleFormulare={formulare}
                  />
                </Box>
                <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
                  <LohnartenDesktopUebersicht
                    monatsErgebnisse={monatsErgebnisse}
                    Bearbeiten={Bearbeiten}
                    client={client}
                    accessToken={accessToken}
                    formularliste={formularliste}
                    Reload={Reload}
                    alleFormulare={formulare}
                  />
                </Box>
              </>
            ) : (
              <>
                <Box sx={{ display: { xs: "block", sm: "block", md: "none" } }}>{renderMobileAnsicht()}</Box>
                <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>{renderDesktopAnsicht()}</Box>
              </>
            )}
          </Layout>
        </Page>
      </Fragment>
    );
  }

  //Rückgabe
  return (
    <>
      <Routes>
        <Route
          path="/:formularnummer"
          element={
            <FormularEingabe
              client={client}
              accessToken={accessToken}
              formular={formularliste[loadIndex.current] ? formularliste[loadIndex.current].art + formular : "F" + formular}
              formularkey={ladenFormular}
              Reload={Reload}
              setFormular={setFormular}
              workflow={workflow}
              setFormularkey={setLadenFormular}
              ans={ans}
              ankey={ankey.current}
              bearbeiten={bearbeiten}
            />
          }
        />
        <Route path="/" element={Uebersicht()} />
      </Routes>

      <Dialog open={formularDetailsLoa !== -1} onClose={() => setFormularDetailsLoa(-1)} maxWidth="md" fullWidth>
        <DialogTitle>
          <Typography variant="h6">{hatAuszahlung ? "Diese Werte werden ausgezahlt" : "Aus Formular entstehende Lohnarten"}</Typography>

          {formularLoa?.statusorig === "von Personalabteilung bearbeitet" ? (
            <>
              <Typography variant="body1">Bearbeitungskommentar: </Typography>{" "}
              <div
                style={{
                  color: "#6b7280",
                  backgroundColor: "#f9fafb",
                  fontSize: "0.875rem",
                  textAlign: "left",
                  maxWidth: "28rem",
                  width: "100%",
                  border: "1px solid #d1d5db",
                  borderRadius: "0.5rem",
                  margin: "0.5rem 0",
                  padding: "0.75rem",
                }}
              >
                {formularLoa?.bearbeitungsKommentar}
              </div>
            </>
          ) : (
            ""
          )}
        </DialogTitle>

        <DialogContent>
          {hatAuszahlung ? (
            <>
              {/* --- Auszahlung: Desktop --- */}
              <Paper sx={{ display: { xs: "none", sm: "block" } }}>
                <Table size="small" aria-label="auszahlung">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Konto</TableCell>
                      <TableCell align="center">Wert</TableCell>
                      <TableCell align="center">Auszahlungs Zeitraum</TableCell>
                      <TableCell align="center">Art</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formularLoa?.auszahlung?.map((a, idx) => (
                      <TableRow key={idx}>
                        <TableCell align="center" component="th" scope="row">
                          {a.selectedKonto?.bez}
                        </TableCell>
                        <TableCell align="center">{a.auszahlenSummeEingabe}</TableCell>
                        <TableCell align="center">{a.auszahlungsZeitraum}</TableCell>
                        <TableCell align="center">{a.selectedKonto?.auszahlungsart === "T" ? "Tage" : "Stunden"}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>

              {/* --- Auszahlung: Mobile --- */}
              <Box sx={{ display: { xs: "block", sm: "none" } }}>
                <Table size="small" aria-label="auszahlung-mobile">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formularLoa?.auszahlung?.map((a, idx) => (
                      <TableRow key={idx}>
                        <TableCell>
                          <Grid container justifyContent="center">
                            <Grid item xs={12} align="center">
                              <Typography color="secondary" component="span">
                                Konto:{" "}
                              </Typography>
                              <Typography component="span">{a.selectedKonto?.bez}</Typography>
                            </Grid>
                            <Grid item xs={12} align="center">
                              <Typography color="secondary" component="span">
                                Wert:{" "}
                              </Typography>
                              <Typography component="span">{a.auszahlenSummeEingabe}</Typography>
                            </Grid>
                            <Grid item xs={12} align="center">
                              <Typography component="span">{a.auszahlungsZeitraum}</Typography>
                            </Grid>
                            <Grid item xs={12} align="center">
                              <Typography color="secondary" component="span">
                                Art:{" "}
                              </Typography>
                              <Typography component="span">{a.selectedKonto?.auszahlungsart === "T" ? "Tage" : "Stunden"}</Typography>
                            </Grid>
                          </Grid>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </>
          ) : (
            <>
              {/* --- Lohnarten: Desktop --- */}
              <Paper sx={{ display: { xs: "none", sm: "block" } }}>
                <Table size="small" aria-label="history">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">Bezeichnung</TableCell>
                      <TableCell align="center">Zeitraum</TableCell>
                      <TableCell align="center">Tage</TableCell>
                      <TableCell align="center">Stunden</TableCell>
                      <TableCell align="center">Betrag</TableCell>
                      <TableCell align="center">Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formularLoa?.lohnarten?.map((loa) => {
                      var status = loa.status;
                      var color = loa.statusColor;
                      if (formularLoa?.status === "B") {
                        status = "Formular noch nicht genehmigt";
                        color = "yellow";
                      }
                      if (!status && formularLoa?.status === "G") {
                        status = "Zur Übernahme bereit";
                        color = "blue";
                      }
                      if (loa.bearbeitet) {
                        return (
                          <TableRow key={loa.key}>
                            <TableCell align="center" component="th" scope="row">
                              {loa.bezeichnung}
                            </TableCell>
                            <TableCell align="center" component="th" scope="row">
                              <Typography>&nbsp; {formatDate(loa.zr, "YYYYMM", "MM/YYYY")}</Typography>
                              {loa.bearbeitet && loa.zr !== loa.zr_beantragt && (
                                <Typography color={"grey"}>* {formatDate(loa.zr_beantragt, "YYYYMM", "MM/YYYY")}</Typography>
                              )}
                            </TableCell>
                            <TableCell align="center" component="th" scope="row">
                              <Typography>&nbsp;{loa.tage}</Typography>
                              {loa.bearbeitet && loa.tage !== loa.tage_beantragt && <Typography color={"grey"}>*{loa.tage_beantragt} </Typography>}
                            </TableCell>
                            <TableCell align="center" component="th" scope="row">
                              <Typography>&nbsp; {loa.stunden}</Typography>
                              {loa.bearbeitet && loa.stunden !== loa.stunden_beantragt && <Typography color={"grey"}>*{loa.stunden_beantragt}</Typography>}
                            </TableCell>
                            <TableCell align="center">
                              <Typography>&nbsp;{loa.betrag} €</Typography>
                              {loa.bearbeitet && loa.betrag !== loa.betrag_beantragt && <Typography color={"grey"}>*{loa.betrag_beantragt} €</Typography>}
                            </TableCell>
                            <TableCell align="center">
                              <Chip label={status} variant="outlined" style={{ backgroundColor: theme.palette.blocks[color] }} />
                            </TableCell>
                          </TableRow>
                        );
                      } else {
                        return (
                          <TableRow key={loa.key}>
                            <TableCell align="center" component="th" scope="row">
                              {loa.bezeichnung}
                            </TableCell>
                            <TableCell align="center" component="th" scope="row">
                              {loa.zr}
                            </TableCell>
                            <TableCell align="center" component="th" scope="row">
                              {loa.tage}
                            </TableCell>
                            <TableCell align="center" component="th" scope="row">
                              {loa.stunden}
                            </TableCell>
                            <TableCell align="center">{loa.betrag} €</TableCell>
                            <TableCell align="center">
                              <Chip label={status} variant="outlined" style={{ backgroundColor: theme.palette.blocks[color] }} />
                            </TableCell>
                          </TableRow>
                        );
                      }
                    })}
                  </TableBody>
                </Table>
              </Paper>

              {/* --- Lohnarten: Mobile --- */}
              <Box sx={{ display: { xs: "block", sm: "none" } }}>
                <Table size="small" aria-label="history">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {formularLoa?.lohnarten?.map((loa) => {
                      var status = loa.status;
                      var color = loa.statusColor;
                      if (formularLoa?.status === "B") {
                        status = "Formular noch nicht genehmigt";
                        color = "yellow";
                      }
                      if (!status && formularLoa?.status === "G") {
                        status = "Zur Übernahme bereit";
                        color = "blue";
                      }
                      return (
                        <TableRow key={loa.key}>
                          <TableCell>
                            <Grid container justifyContent="center">
                              <Grid item xs={12} align="center" style={{ display: "" }}>
                                <Typography> {loa.bezeichnung}</Typography>
                              </Grid>
                              <Grid item xs={12} align="center" style={{ display: "" }}>
                                <Typography> &nbsp; {formatDate(loa.zr, "YYYYMM", "MM/YYYY")}</Typography>
                              </Grid>
                              {loa.bearbeitet && loa.zr !== loa.zr_beantragt && (
                                <Grid item xs={12} align="center" style={{ display: "" }}>
                                  <Typography color={"grey"}>* {formatDate(loa.zr_beantragt, "YYYYMM", "MM/YYYY")}</Typography>
                                </Grid>
                              )}
                              <Grid item xs={12} align="center" style={{ display: "" }}>
                                <Typography>&nbsp;{loa.tage + " / " + loa.stunden + " / " + loa.betrag + "€"}</Typography>
                              </Grid>
                              {loa.bearbeitet &&
                              (loa.tage !== loa.tage_beantragt || loa.stunden !== loa.stunden_beantragt || loa.betrag !== loa.betrag_beantragt) ? (
                                <Grid item xs={12} align="center" style={{ display: "" }}>
                                  <Typography color={"grey"}>
                                    * {loa.tage_beantragt + " / " + loa.stunden_beantragt + " / " + loa.betrag_beantragt + "€"}
                                  </Typography>
                                </Grid>
                              ) : (
                                ""
                              )}
                              <Grid item xs={12} align="center" style={{ display: "" }}>
                                <Typography
                                  style={{
                                    fontWeight: 400,
                                    fontSize: "90%",
                                    display: "inline-block",
                                  }}
                                >
                                  Tage/Stunden/Betrag
                                </Typography>
                              </Grid>
                              <Grid item xs={12}>
                                <Box display="flex" justifyContent="center">
                                  <Chip label={status} variant="outlined" style={{ backgroundColor: theme.palette.blocks[color] }} />
                                </Box>
                              </Grid>
                            </Grid>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </Box>
            </>
          )}

          {formularLoa?.statusorig === "von Personalabteilung bearbeitet" && <Typography color={"grey"}>*Ursprünglich beantragte Werte</Typography>}
        </DialogContent>
        <DialogActions>
          <Button style={{ marginRight: "10px" }} variant="secondary" display="flex" onClick={() => setFormularDetailsLoa(-1)}>
            {t("Abbrechen")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={filterDialog} onClose={() => setFilterDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>Filter</DialogTitle>
        <DialogContent>
          <Grid container justifyContent="center" spacing={1} style={{ paddingTop: 20 }}>
            <Grid item xs={12} md={5}></Grid>
            <Grid item xs={12} md={2}>
              <TextField
                fullWidth
                size="small"
                type="date"
                label="Formulare anzeigen ab"
                value={datumsFilter}
                onChange={(e) => setDatumsFilter(e.target.value)}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <Typography align="center" variant="body2">
                {t("Nach Formular filtern")}
              </Typography>
              <Select
                id="formularFilterMobil3"
                multiple
                fullWidth
                value={formularFilterSelectValue}
                onChange={(event) => {
                  setFormularFilterSelectValue(event.target.value);
                }}
                size="small"
                // input={<OutlinedInput label="Name" />}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {formularFilterOptions.map((formular, index) => (
                  <MenuItem key={formular.value} value={formular.value}>
                    {formular.value}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
            <Grid item xs={12} md={2}>
              <Typography align="center" variant="body2">
                {t("Nach Status filtern")}
              </Typography>
              <Select
                id="formularFilterMobil3"
                multiple
                fullWidth
                value={statusFilterSelectValue}
                onChange={(event) => {
                  setStatusFilterSelectValeue(event.target.value);
                }}
                size="small"
                // input={<OutlinedInput label="Name" />}
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {statusFilterOptions.map((formular, index) => (
                  <MenuItem key={formular.value} value={formular.value}>
                    {formular.value}
                  </MenuItem>
                ))}
              </Select>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button style={{ marginRight: "10px" }} variant="secondary" display="flex" onClick={() => setFilterDialog(false)}>
            {t("Abbrechen")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default Formulare;
